import React from 'react'

const Contact = () => {
  return (
    <div>
        <h1>This contact page</h1>
    </div>
  )
}

export default Contact